<kendo-datepicker class="kendoInput dateWidth"
                  [value]="start"
                  format="MM/dd/yyyy"
                  (valueChange)="filterRange($event, end)"
                  [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}" style="width:100px"
                  [max]="end">
</kendo-datepicker>
-
<kendo-datepicker class="kendoInput dateWidth"
                  [value]="end"
                  format="MM/dd/yyyy"
                  (valueChange)="filterRange(start, $event)"
                  [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}" style="width:100px" [min]="start">
</kendo-datepicker>
<button *ngIf="hasFilter"
        class="k-button k-button-icon"
        title="Clear"
        (click)="clearFilter()">
  <span class="k-icon k-i-filter-clear"></span>
</button>
